import { Checkbox, DataHeader, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutProspectActivity extends Layout {
    checkboxAllowAutoDate: Checkbox;
    dataheaderDataheader: DataHeader;
    panelProspectActivity: Panel;
    sourceProspectActivity: DataSource;
    textboxAssignedUserId: Textbox;
    textboxDays: Textbox;
    textboxDefAssign: Textbox;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxInfoPacketId: Textbox;
    textboxNextId: Textbox;
}
